import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RxFillAlertsCount {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  RxFillAlertsCountData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: RxFillAlertsCount = {
  isLoading: false,
  error: false,
  message: null,
  RxFillAlertsCountData: [],
  Items: [],
  Pagination: [],
};

const RxFillAlertsCountSlice = createSlice({
  name: "RxFillAlertsCount",
  initialState,
  reducers: {
    loadingRxFillAlertsCount: (
      state: RxFillAlertsCount,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setRxFillAlertsCount: (
      state: any,
      action: PayloadAction<RxFillAlertsCount>
    ) => {
      return action.payload;
    },
  },
});

export const { loadingRxFillAlertsCount, setRxFillAlertsCount } =
  RxFillAlertsCountSlice.actions;
export default RxFillAlertsCountSlice.reducer;
